import { useEffect, useState } from "react";
import { NAV_LINKS } from "../../data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className="fixed inset-x-0 top-0 z-50 border-b transition-colors duration-500"
      style={{
        borderColor: scrolled ? "var(--border)" : "transparent",
        background: scrolled ? "color-mix(in srgb, var(--bg) 82%, transparent)" : "transparent",
        backdropFilter: scrolled ? "blur(16px)" : "none",
      }}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-head text-lg font-semibold tracking-tight text-[color:var(--text)]"
        >
          Graham Wetzbarger
        </a>
        <div className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.slice(0, -1).map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-accent text-[11px] uppercase tracking-[0.18em] text-[color:var(--text-2)] transition-colors hover:text-[color:var(--text)]"
            >
              {l.label}
            </a>
          ))}
        </div>
        <a
          href="#contact"
          data-testid="nav-cta"
          className="border px-5 py-2.5 text-[11px] font-medium uppercase tracking-[0.18em] transition-transform hover:-translate-y-0.5"
          style={{
            background: "var(--accent)",
            color: "var(--on-accent)",
            borderColor: "var(--accent)",
            borderRadius: "var(--radius-tok)",
          }}
        >
          Get in Touch
        </a>
      </nav>
    </header>
  );
};
